import { render, staticRenderFns } from "./EventReservationForm.vue?vue&type=template&id=487ec81b&"
import script from "./EventReservationForm.vue?vue&type=script&lang=js&"
export * from "./EventReservationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports